/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UiLabel { 
    kk?: string;
    ru?: string;
    en?: string;
    uz?: string;
    tg?: string;
}

